import { LuDownload, LuX } from 'react-icons/lu'
import { usePwaInstall } from '../hooks/usePwaInstall.js'
import { useState } from 'react'

const PwaInstallBanner = () => {
  const { canInstall, prompt } = usePwaInstall()
  const [dismissed, setDismissed] = useState(false)

  if (!canInstall || dismissed) return null

  return (
    <div className="pwa-banner" role="banner">
      <span className="pwa-banner__text">
        Add Keyzee to your home screen for faster access.
      </span>
      <button type="button" className="btn btn-sm btn-primary pwa-banner__install" onClick={prompt}>
        <LuDownload aria-hidden="true" /> Install
      </button>
      <button
        type="button"
        className="pwa-banner__dismiss"
        aria-label="Dismiss install banner"
        onClick={() => setDismissed(true)}
      >
        <LuX aria-hidden="true" />
      </button>
    </div>
  )
}

export default PwaInstallBanner
